import React from 'react'
import defaultPackIconClearBg from '_images/shared/ugc-clear-bg.svg';

class ClassBar extends React.Component {
  render() {
    if (this.props.classType == 'certified') {
      return this.renderCertifiedClass();
    } else {
      return this.renderUgcClass();
    }
  }

  renderCertifiedClass() {
    var cat = this.props.classData.category;
    var catId = cat.id;
    var url = "/learn/" + cat.key;
    var learnerLabel = cat.subscriber_count > 1 ? "Learners" : "Learner";

    return (
      <li key={catId} className="subject-bar certified">

        <div className="class-link-wrapper" onClick={(e) => {this.convertThenVisit(e, url, this.props.searchId, catId)}}>
          <a className="subject-bar-link" href={url}>{cat.name}</a>
        </div>

        <div className="artwork-and-metadata">
          <div className='artwork'>
            <img className="subject-icon" src={cat.app_icon_url} />
          </div>
          <div className='metadata'>
            <div className='subject-info'>
              <h4 className='subject-name'>{cat.name}</h4>
              <div className='subject-headline' dangerouslySetInnerHTML={{__html: cat.market_headline}}></div>
            </div>
          </div>
        </div>

        <div className="supplemental-info-and-actions">
          <div className='supplemental-info'>
            <div className='stats-item'>
              <div className='stat-icon subject-cards decks-icon'></div>
              <div className='stat-value'>{this.numberWithDelimeter(cat.deck_count)}</div>
              <div className='stat-title'>Decks</div>
            </div>

            <div className='stats-item'>
              <div className='stat-icon subject-cards flashcards-icon'></div>
              <div className='stat-value'>{this.numberWithDelimeter(cat.card_count)}</div>
              <div className='stat-title'>Flashcards</div>
            </div>

            <div className='stats-item'>
              <div className='stat-icon subject-cards learners-icon'></div>
              <div className='stat-value'>{this.numberWithDelimeter(cat.subscriber_count)}</div>
              <div className='stat-title'> {learnerLabel}</div>
            </div>
          </div>
          <div className='actions'></div>
        </div>
      </li>
    );
  }

  renderUgcClass() {
    var pack = this.props.classData.pack;
    var packId = pack.id;
    var url = "/packs/" + (pack.path_and_id || pack.id); // until elasticseach is fully-updated we need to fallback to "id"

    var learnerLabel = pack.subscriber_count > 1 ? "Learners" : "Learner";

    var packIconUrl = this.getPackIconUrl(pack);

    return (
      <li key={pack.id} className="subject-bar ugs">

        <div className="class-link-wrapper" onClick={(e) => {this.convertThenVisit(e, url, this.props.searchId, packId)}}>
          <a className="subject-bar-link" href={url}>{pack.name}</a>
        </div>

        <div className="artwork-and-metadata">
          <div className='artwork'>
            <img className="subject-icon" src={packIconUrl} />
          </div>
          <div className='metadata'>
            <div className='subject-info'>
              <h4 className='subject-name'>{pack.name}</h4>
              <h5 className='author-name'>{this.renderCreatorName(pack)}</h5>
              <div className='sample-deck-titles'>
                {this.renderSampleDecks(pack)}
              </div>
            </div>
          </div>
        </div>

        <div className="supplemental-info-and-actions">
          <div className='supplemental-info'>
            <div className='stats-item'>
              <div className='stat-icon subject-cards decks-icon'></div>
              <div className='stat-value'>{this.numberWithDelimeter(pack.deck_count)}</div>
              <div className='stat-title'>Decks</div>
            </div>

            <div className='stats-item'>
              <div className='stat-icon subject-cards flashcards-icon'></div>
              <div className='stat-value'>{this.numberWithDelimeter(pack.card_count)}</div>
              <div className='stat-title'>Flashcards</div>
            </div>

            <div className='stats-item'>
              <div className='stat-icon subject-cards learners-icon'></div>
              <div className='stat-value'>{this.numberWithDelimeter(pack.subscriber_count)}</div>
              <div className='stat-title'> {learnerLabel}</div>
            </div>
          </div>
          <div className='actions'></div>
        </div>
      </li>
    );
  }

  renderCreatorName(pack) {
    if (!pack.creator_name) {
      return null;
    }

    return (
      <h5 className="subject-identifier">
        By: {pack.creator_name}
      </h5>
    );
  }

  renderSampleCategoryPackDecks(cat) {
    if (cat.pack && cat.pack.decks && cat.pack.decks.length > 0) {
      return this.renderSampleDecks(cat.pack);
    }

    if (cat.packs && cat.packs[0] && cat.packs[0].decks && cat.packs[0].decks.length > 0) {
      return this.renderSampleDecks(cat.packs[0]);
    }

    return null;
  }

  renderSampleDecks(pack) {
    let decks,
        lim = 3,
        sampleDecks;

    if (!(pack.decks && pack.decks.length > 0)) { return null; }

    decks = pack.decks;

    sampleDecks = decks.slice(0, lim).map((deck, i) => {
      let delim = (i+1 < lim && i+1 < decks.length) ? ', ' : '';
      return (<span className="sample-deck" key={deck.id}>{deck.name}{delim}</span>);
    })

    return (
      <div className="sample-deck-titles">
        <span className="deck-titles">
          {sampleDecks}
        </span>
      </div>
    );
  }

  renderPackDecks(pack) {
    let decks,
        lim = 3,
        rows,
        more = null;

    if (!(pack.decks && pack.decks.length > 0)) { return null; }

    decks = pack.decks;

    rows = decks.slice(0, lim).map((deck) => {
      return this.renderPackDeck(deck);
    })

    if (decks.length > lim) {
      more = this.renderMorePackDeckFlag();
    }

    return (
      <ul className="pack-decks">
        {rows}
        {more}
      </ul>
    );
  }

  renderPackDeck(deck) {
    let cardLabel = deck.card_count == 1 ? 'card' : 'cards';

    return (
      <li className="pack-deck" key={deck.id}>
        <span className="pack-deck-name">{deck.name}</span>
        <span className="pack-deck-card-count">&nbsp;({deck.card_count} {cardLabel})</span>
      </li>
    )
  }

  renderMorePackDeckFlag() {
    return (
      <div className="pack-deck-more-flag">and more...</div>
    );
  }

  convertThenVisit(e, url, searchId, resultId) {
    e.preventDefault();
    e.stopPropagation();

    // open window right away and then record search conversion
    const augmentedUrl = url + '?origin=genome'; // TODO: Remove this param after we move everyone to new dashboard (see similar in searchResultsTracker.js)
    const newWindow = window.open(augmentedUrl, '_self', 'noopener');

    // try to convert
    $.get('/api/search_results/' + searchId + '/result/' + resultId + '/convert')
      .always(function(data) {
        console.log('Search Conversion attempted:', data);
      }
    );
  }

  getPackIconUrl = (pack={}) => {
    const packIconUrl = pack.app_icon_url || defaultPackIconClearBg;

    if (packIconUrl.indexOf('/ugs.png') != -1) {
      return defaultPackIconClearBg;
    }

    if (packIconUrl.indexOf('/ugc-clear-bg.svg') != -1) {
      return defaultPackIconClearBg; // ensures that fingerprinted version is passed to img tag
    }

    if (packIconUrl.indexOf('assets') == 0) {
      return '/' + packIconUrl;
    }

    return packIconUrl;
  }

  numberWithDelimeter(value) {
    return (value+"").split("").reverse().join("").replace(/(\d{3})(?=\d)/g, '$1,').split("").reverse().join("");
  }
}

export default ClassBar;
